<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >CONFIGURAÇÕES</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>
    <v-form class="pt-0" ref="form" lazy-validation>
      <v-row no-gutters>
        <v-col cols="12" xl="1" lg="2" md="2" sm="4" xs="8">
          <v-text-field
            prepend-inner-icon="timer"
            v-model="config.tempo_entrega"
            filled
            v-mask="'###'"
            dense
            @blur="mudarValor('tempo_entrega', config.tempo_entrega)"
            @keyup.enter="mudarValor('tempo_entrega', config.tempo_entrega)"
            label="Tempo de entrega"
            required
            hint="Minutos"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="1" lg="2" md="2" sm="4" xs="8">
          <v-text-field
            prepend-inner-icon="timer"
            v-model="config.qtd_hora_encomenda"
            filled
            v-mask="'###'"
            dense
            @blur="mudarValor('qtd_hora_encomenda', config.qtd_hora_encomenda)"
            @keyup.enter="
              mudarValor('qtd_hora_encomenda', config.qtd_hora_encomenda)
            "
            label="Qtde de Horas para Encomenda"
            required
            hint="Horas"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="6" lg="2" md="2" sm="4" xs="8">
          <v-text-field
            prepend-inner-icon="timer"
            v-model="config.tempo_tolerancia_entrega_programada"
            filled
            v-mask="'###'"
            dense
            @blur="
              mudarValor(
                'tempo_tolerancia_entrega_programada',
                config.tempo_tolerancia_entrega_programada
              )
            "
            hint="Minutos"
            persistent-hint
            @keyup.enter="
              mudarValor(
                'tempo_tolerancia_entrega_programada',
                config.tempo_tolerancia_entrega_programada
              )
            "
            label="Tolerância entrega programada"
            required
          ></v-text-field>
        </v-col>
        </v-row>
        <v-row no-gutters>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-mask="'##:##'"
            prepend-inner-icon="access_time"
            v-model="config.hora_inicial"
            @blur="mudarValor('hora_inicial', config.hora_inicial)"
            @keyup.enter="mudarValor('hora_inicial', config.hora_inicial)"
            filled
            dense
            label="Abertura dia útil"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-model="config.hora_final"
            prepend-inner-icon="timer_off"
            @blur="mudarValor('hora_final', config.hora_final)"
            @keyup.enter="mudarValor('hora_final', config.hora_final)"
            filled
            v-mask="'##:##'"
            dense
            label="Fechamento dia útil"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-mask="'##:##'"
            prepend-inner-icon="access_time"
            v-model="config.hora_abertura_sabado"
            @blur="mudarValor('hora_abertura_sabado', config.hora_abertura_sabado)"
            @keyup.enter="mudarValor('hora_abertura_sabado', config.hora_abertura_sabado)"
            filled
            dense
            label="Abertura sábado"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-model="config.hora_fechar_sabado"
            prepend-inner-icon="timer_off"
            @blur="mudarValor('hora_fechar_sabado', config.hora_fechar_sabado)"
            @keyup.enter="mudarValor('hora_fechar_sabado', config.hora_fechar_sabado)"
            filled
            v-mask="'##:##'"
            dense
            label="Fechamento sábado"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>

        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-mask="'##:##'"
            prepend-inner-icon="access_time"
            v-model="config.hora_abertura_domingo"
            @blur="mudarValor('hora_abertura_domingo', config.hora_abertura_domingo)"
            @keyup.enter="mudarValor('hora_abertura_domingo', config.hora_abertura_domingo)"
            filled
            dense
            label="Abertura domingo"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-model="config.hora_fechar_domingo"
            prepend-inner-icon="timer_off"
            @blur="mudarValor('hora_fechar_domingo', config.hora_fechar_domingo)"
            @keyup.enter="mudarValor('hora_fechar_domingo', config.hora_fechar_domingo)"
            filled
            v-mask="'##:##'"
            dense
            label="Fechamento domingo"
            required
          ></v-text-field>
        </v-col>
      </v-row>
        <v-row no-gutters>
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-model="config.taxa_gratis"
            @blur="mudarValor('taxa_gratis', config.taxa_gratis)"
            @keyup.enter="mudarValor('taxa_gratis', config.taxa_gratis)"
            prepend-inner-icon="monetization_on"
            label="Taxa Grátis"
            v-currency="{
              currency: null,
              locale: 'pt-PT',
              precision: 2,
            }"
            filled
            dense
            clearable
            required
          ></v-text-field>
        </v-col>
      
        <v-col cols="12" md="2" lg="2" sm="4" xs="8">
          <v-text-field
            v-model="config.pedido_minimo"
            @blur="mudarValor('pedido_minimo', config.pedido_minimo)"
            @keyup.enter="mudarValor('pedido_minimo', config.pedido_minimo)"
            prepend-inner-icon="monetization_on"
            label="Pedido Mínimo"
            v-currency="{
              currency: null,
              locale: 'pt-BR',
              precision: 2,
            }"
            filled
            dense
            clearable
            required
          ></v-text-field>
        </v-col>
       

        <v-col cols="12" md="2" lg="2" sm="6" xs="12">
          <v-text-field
            v-model="config.km_taxa_gratis"
            @blur="mudarValor('km_taxa_gratis', config.km_taxa_gratis)"
            @keyup.enter="mudarValor('km_taxa_gratis', config.km_taxa_gratis)"
            prepend-inner-icon="mdi-map-marker"
            label="Distância para Taxa Grátis"
            v-currency="{
              currency: 1,
              locale: 'en',
              precision: 1,
              prefix:'Km'
            }"
            filled
            dense
            clearable
            required
          ></v-text-field>
         
        </v-col>

      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="2" lg="2" sm="6" xs="12">
          <v-checkbox
            v-model="config.encomenda_dia_atual"
            @change="
              mudarValor('encomenda_dia_atual', config.encomenda_dia_atual)
            "
            label="Encomenda para o dia atual"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <v-checkbox
            v-model="config.aceita_encomenda"
            @change="mudarValor('aceita_encomenda', config.aceita_encomenda)"
            label="Aceita Encomenda"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <v-checkbox
            v-model="config.aceita_pedido_normal"
            @change="
              mudarValor('aceita_pedido_normal', config.aceita_pedido_normal)
            "
            label="Aceita Pedido Normal"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <v-checkbox
            v-model="config.chk_comanda"
            @change="
              mudarValor('chk_comanda', config.chk_comanda)
            "
            label="Ler comanda"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-0 mb-5">
        <v-col cols="12" md="2" lg="2" sm="6" xs="12">
          <v-checkbox
            v-model="config.aceita_pix"
            @change="mudarValor('aceita_pix', config.aceita_pix)"
            label="Aceita Pix"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
         <v-col cols="12" md="2" lg="2" sm="6" xs="12">
          <v-checkbox
            v-model="config.aceita_dinheiro"
            @change="mudarValor('aceita_dinheiro', config.aceita_dinheiro)"
            label="Aceita Dinheiro"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="2" lg="2" sm="6" xs="12">
          <v-checkbox
            v-model="config.aceita_cartao"
            @change="mudarValor('aceita_cartao', config.aceita_cartao)"
            label="Aceita Cartão de Crédito"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xl="2" md="2" lg="2" sm="2" xs="12">
          <v-switch
            class="text-rigth"
            color="primary"
            :label="`Taxa por  ${config.chk_taxa_bairro_distancia}`"
            @change="mudarValor('chk_taxa_bairro_distancia', config.chk_taxa_bairro_distancia)"
            v-model="config.chk_taxa_bairro_distancia"
            false-value="bairro"
            true-value="distancia"
          ></v-switch>
        </v-col>
        <v-col offset="2" cols="12" md="2" lg="2" sm="6" xs="12">
          <v-checkbox
            v-model="config.pagto_entrega"
            @change="mudarValor('pagto_entrega', config.pagto_entrega)"
            label="Aceita Pagamento na Entrega"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        
      </v-row>

      <v-row no-gutters class="mt-0 mb-5">
        <v-col cols="12" xl="2" md="3" sm="6" lg="3" xs="12">
          <v-checkbox
            prepend-icon="mdi-bell"
            v-model="config.alerta_sonoro_pedido_recebido"
            @change="
              mudarValor(
                'alerta_sonoro_pedido_recebido',
                config.alerta_sonoro_pedido_recebido
              )
            "
            label="Alerta sonoro Pedido"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" xl="2" md="2" lg="2" sm="2" xs="12">
          <v-switch
            class="text-rigth"
            color="success"
            :label="`Loja:  ${checkStatus(config.aberto)}`"
            @change="mudarValor('aberto', config.aberto)"
            v-model="config.aberto"
            false-value="false"
            true-value="true"
          ></v-switch>
        </v-col>

        <v-col cols="12" md="2" lg="3" sm="6" xs="12">
          <v-switch
            class="text-rigth"
            color="success"
            :label="`Sistema:  ${checkStatusManutencao(config.manutencao)}`"
            @change="mudarValor('manutencao', config.manutencao)"
            v-model="config.manutencao"
            false-value="true"
            true-value="false"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="2" lg="3" sm="6" xs="12">
          <v-checkbox
            v-model="config.retira_loja"
            @change="mudarValor('retira_loja', config.retira_loja)"
            label="Retirada no local"
            required
            false-value="false"
            true-value="true"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-0 mb-5"></v-row>
      <v-col cols="12" md="3" lg="3" sm="3" xs="12">
            <v-text-field
            clearable
            prepend-inner-icon="mdi-key-variant"
            v-model="config.key_maps"
             @blur="mudarValor('key_maps', config.key_maps)"
            @keyup.enter="mudarValor('key_maps', config.key_maps)"
            type="password"
            filled
            dense
            label="Chave Google Maps"
            required
          ></v-text-field>
            </v-col>
          </v-row>
      <v-row no-gutters class="mt-0 mb-5">
      <v-col cols="12" xl="2" lg="2" md="2" sm="4" xs="12">
          <v-file-input
            v-model="imageFile"
            label="Logo da Loja"
            filled
            dense
            @change="mudarValor('url_logo', imageFile)"
            accept="image/*"
          ></v-file-input>
          </v-col>
          <v-col cols="12" xl="2" lg="2" md="2" sm="4" xs="12"><v-img
            
            width="200"
             :src="config.url_logo"
             
           >
             <template v-slot:placeholder>
               <v-row class="fill-height ma-0" align="center" justify="center">
                 <v-progress-circular
                   indeterminate
                   color="grey lighten-5"
                 ></v-progress-circular>
               </v-row>
             </template>
           </v-img></v-col>  
        </v-col>
        </v-row>
        
      <v-row no-gutters>
        <v-col cols="12" md="3" lg="3" sm="3" xs="12">
          <v-row no-gutters>
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <div style="text-align:left">Dias de funcionamento</div>
            </v-col>
          </v-row>
          <v-row no-gutters class="ml-5">
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <v-checkbox
                v-model="config.todos"
                color="success"
                @change="marcaTodos()"
                value="todos"
                label="Todos dias"
                indeterminate
              ></v-checkbox>

              <v-checkbox
                v-model="config.dia_1"
                color="success"
                @change="mudarValor('dia1', config.dia_1)"
                label="Domingo"
                false-value="false"
                true-value="true"
              ></v-checkbox>

              <v-checkbox
                v-model="config.dia_2"
                color="success"
                @change="mudarValor('dia2', config.dia_2)"
                label="Segunda-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>

              <v-checkbox
                v-model="config.dia_3"
                color="success"
                @change="mudarValor('dia3', config.dia_3)"
                label="Terça-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
              <v-checkbox
                v-model="config.dia_4"
                color="success"
                @change="mudarValor('dia4', config.dia_4)"
                label="Quarta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
              <v-checkbox
                v-model="config.dia_5"
                color="success"
                @change="mudarValor('dia5', config.dia_5)"
                label="Quinta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
              <v-checkbox
                v-model="config.dia_6"
                color="success"
                @change="mudarValor('dia6', config.dia_6)"
                label="Sexta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
              <v-checkbox
                v-model="config.dia_7"
                color="success"
                @change="mudarValor('dia7', config.dia_7)"
                false-value="false"
                true-value="true"
                label="Sábado"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" lg="9" sm="9" xs="12">
          <v-row no-gutters>
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <div style="text-align:left">Horários de Entrega</div>
            </v-col>
          </v-row>
          <v-row no-gutters class="ml-0">
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_1"
                color="success"
                label="Domingo"
                @change="selDiaSemana($event, 1)"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h1"
                :items="horas"
                @change="selHoraInicial($event, 1)"
                v-model="hora_inicial_1"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h1"
                :items="horas"
                v-model="hora_final_1"
                label="hora final"
                @change="selHoraFinal($event, 1)"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_1"
                :disabled="!dia_h1"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_1, 1)"
                @keyup.enter="mudarQtde(qtd_max_1, 1)"
                label="Limite Pedidos Por Hora"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_2"
                color="success"
                @change="selDiaSemana($event, 2)"
                label="Segunda-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h2"
                :items="horas"
                @change="selHoraInicial($event, 2)"
                v-model="hora_inicial_2"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h2"
                :items="horas"
                @change="selHoraFinal($event, 2)"
                v-model="hora_final_2"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_2"
                :disabled="!dia_h2"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_2, 2)"
                @keyup.enter="mudarQtde(qtd_max_2, 2)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_3"
                color="success"
                @change="selDiaSemana($event, 3)"
                label="Terça-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h3"
                :items="horas"
                @change="selHoraInicial($event, 3)"
                v-model="hora_inicial_3"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h3"
                :items="horas"
                @change="selHoraFinal($event, 3)"
                v-model="hora_final_3"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                :disabled="!dia_h3"
                v-model="qtd_max_3"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_3, 3)"
                @keyup.enter="mudarQtde(qtd_max_3, 3)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_4"
                color="success"
                @change="selDiaSemana($event, 4)"
                label="Quarta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h4"
                :items="horas"
                @change="selHoraInicial($event, 4)"
                v-model="hora_inicial_4"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h4"
                :items="horas"
                @change="selHoraFinal($event, 4)"
                v-model="hora_final_4"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_4"
                :disabled="!dia_h4"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_4, 4)"
                @keyup.enter="mudarQtde(qtd_max_4, 4)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_5"
                color="success"
                @change="selDiaSemana($event, 5)"
                label="Quinta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h5"
                :items="horas"
                @change="selHoraInicial($event, 5)"
                v-model="hora_inicial_5"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h5"
                :items="horas"
                @change="selHoraFinal($event, 5)"
                v-model="hora_final_5"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_5"
                :disabled="!dia_h1"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_5, 5)"
                @keyup.enter="mudarQtde(qtd_max_5, 5)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_6"
                color="success"
                @change="selDiaSemana($event, 6)"
                label="Sexta-feira"
                false-value="false"
                true-value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h6"
                :items="horas"
                @change="selHoraInicial($event, 6)"
                v-model="hora_inicial_6"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h6"
                :items="horas"
                @change="selHoraFinal($event, 6)"
                v-model="hora_final_6"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_6"
                :disabled="!dia_h1"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_6, 6)"
                @keyup.enter="mudarQtde(qtd_max_6, 6)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" xl="2" lg="2" md="2" sm="3" xs="12">
              <v-checkbox
                v-model="dia_7"
                color="success"
                @change="selDiaSemana($event, 7)"
                false-value="false"
                true-value="true"
                label="Sábado"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h7"
                :items="horas"
                @change="selHoraInicial($event, 7)"
                v-model="hora_inicial_7"
                label="hora inicial"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="3" xs="12">
              <v-select
                :disabled="!dia_h7"
                :items="horas"
                @change="selHoraFinal($event, 7)"
                v-model="hora_final_7"
                label="hora final"
                filled
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" xl="2" md="2" lg="2" sm="3" xs="12"
              ><v-text-field
                v-model="qtd_max_7"
                :disabled="!dia_h1"
                filled
                v-mask="'###'"
                dense
                @blur="mudarQtde(qtd_max_7, 7)"
                @keyup.enter="mudarQtde(qtd_max_7, 7)"
                label="Limite Pedidos"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--<v-row no-gutters>
        <v-col cols="12" xl="8" lg="8" md="12" sm="12" xs="12">
          <v-text-field
            prepend-inner-icon="http"
            v-model="config.url_loja"
            filled
            dense
            @blur="mudarValor('url_loja', config.url_loja)"
            @keyup.enter="mudarValor('url_loja', config.url_loja)"
            label="URL Loja"
            required
          ></v-text-field>
        </v-col>
      </v-row>-->
      <!-- <v-row no-gutters>
        <v-label>TESTE</v-label>
        <v-space></v-space>
      <v-col>
        <v-color-picker
          dot-size="7"
          hide-canvas
          hide-inputs
          hide-sliders

          mode="rgba"
          v-model="color_1"
          show-swatches
          swatches-max-height="100"
        >
</v-color-picker>

      </v-col>
      </v-row>-->
    </v-form>
    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <v-btn @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
    <v-snackbar
      :timeout="2000"
      :color="sucesso"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
      text
    >
      {{ textSucesso }}
    </v-snackbar>
    <a href="#" target="_self" id="linkDownload" download></a>
  </v-content>
</template>

<script>
var moment = require("moment");

const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  mounted() {
    //this.buscaNotas();
    this.lista();
    this.listaHorarios();
    this.getAgenda();
    //  this.linkCardapio();
  },

  data: (vm) => ({

     type: 'rgba',
    color_1: 'rgba(255, 0, 255, 1)',
      rgba: { r: 255, g: 0, b: 255, a: 1 },

    hora_abertura_sabado:"00:00",
    hora_fechar_sabado:"23:59",
    hora_inicial_1: "00:00",
    hora_final_1: "23:00",
    hora_inicial_2: "00:00",
    hora_final_2: "23:00",
    hora_inicial_3: "00:00",
    hora_final_3: "23:00",
    hora_inicial_4: "00:00",
    hora_final_4: "23:00",
    hora_inicial_5: "00:00",
    hora_final_5: "23:00",
    hora_inicial_6: "00:00",
    hora_final_6: "23:00",
    hora_inicial_7: "00:00",
    hora_final_7: "23:00",

    dia_1: "",
    dia_2: "",
    dia_3: "",
    dia_4: "",
    dia_5: "",
    dia_6: "",
    dia_7: "",

    qtd_max_1: 0,
    qtd_max_2: 0,
    qtd_max_3: 0,
    qtd_max_4: 0,
    qtd_max_5: 0,
    qtd_max_6: 0,
    qtd_max_7: 0,

    todos: "true",

    dia_h1: false,
    dia_h2: false,
    dia_h3: false,
    dia_h4: false,
    dia_h5: false,
    dia_h6: false,
    dia_h7: false,
    tipo_ent: "",
    sel_produto_agenda: "",
    agendas: [],
    horas: [
      "00:00",
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
    ],
    agenda_produto: {
      qtd_max: "",
      dia_semana: "",
      hora_inicial: "",
      hora_final: "",
    },
    agenda: { dia_semana: "", qtd_max: 0 },
    textSucesso: "",
    multiline: true,
    textSnack: "",
    snackbarSuccess: false,
    sucesso: "botao_sucesso",
    error: "error",
    tempo: 5000,
    mode: "vertical",
    snackbar: false,
    date_ini: new Date().toISOString().substr(0, 10),
    date_fim: moment().format("YYYY-MM-01"),
    dateFimFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateIniFormatted: moment().format("01/MM/YYYY"),
    menu1: false,
    menu2: false,
    loading_table: false,
    headers: [],
    search: "",
    loading_filtrar: false,
    loading_baixar: false,
    items: [],
    checkbox: false,
    dias_entrega: [],
    horarios_entrega: [],
    horarios_to_sel: [
      "01:00",
      "02:00",
      "03:00",
      "04:00",
      "05:00",
      "06:00",
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "20:00",
      "21:00",
      "22:00",
      "23:00",
      "24:00",
    ],
    imageFile: "",
    config: {
      key_maps:"",  
      taxa_gratis: "",
      km_taxa_gratis:"",
      pedido_minimo: "",
      url_loja: "",
      url_logo: "",
      tempo_entrega: "",
      hora_inicial: "",
      hora_final: "",
      hora_abertura_sabado:"00:00",
      hora_fechar_sabado:"23:59",
      hora_abertura_domingo:"00:00",
      hora_fechar_domingo:"23:59",
      retira_loja: "",
      aberto: "",
      chk_taxa_bairro_distancia:"",
      manutencao: "",
      dia_1: "",
      dia_2: "",
      dia_3: "",
      dia_4: "",
      dia_5: "",
      dia_6: "",
      dia_7: "",
      todos: "",
      tempo_tolerancia_entrega_programada: 0,
      qtde_mesa: "",
      chk_comanda:"",
      aceita_dinheiro:1,
      aceita_pix:0,
    },
    link_cardapio: "",
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    headers: [
      {
        text: "Chave",
        sortable: true,
        align: "left",
        value: "chave",
      },
      {
        text: "Data",
        value: "data",
      },
      {
        text: "Número",
        value: "nf_numero",
        align: "right",
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
    ],
  }),
  computed: {
    computedDateInFormatted() {
      return this.formatDate(this.date_ini);
    },
    computedDateFimFormatted() {
      return this.formatDate(this.date_fim);
    },
  },

  watch: {
    date_ini(val) {
      this.dateIniFormatted = this.formatDate(this.date_ini);
    },
    date_fim(val) {
      this.dateFimFormatted = this.formatDate(this.date_fim);
    },
  },
  methods: {
    selDiaSemana(check, val, id) {

        if(!this.$can('config_update|admin.loja')) {
          this.snackbar = true;
          this.textSnack = "Você não tem permissão para executar esta ação.";
          return;
        } 
        eval("this.dia_h" + val + "=" + check);
        //eval("this.$refs." + id + ".");
        //this.agenda_produto.id_produto = this.sel_produto_agenda;
        this.agenda_produto.dia_semana = val;
        this.agenda_produto.qtd_max = eval("this.qtd_max_" + val);
        this.agenda_produto.hora_inicial = eval("this.hora_inicial_" + val);
        this.agenda_produto.hora_final = eval("this.hora_final_" + val);

        if (check == "true") {
          // this.showLabel = true;
          eval("this.cor_" + val + "='botao_sucesso'");
          for (let i = 1; i < 8; i++) {
            if (eval("this.dia_" + i) == "false") {
              console.log(i + "" + eval("this.dia_" + i));
              eval("this.cor_" + i + "= 'error'");
            }

            //   console.log(i + "" + eval("this.dia_" + i));
            //  eval("this.cor_" + i + "= 'error'");
            //}
          }

          this.atualizaDiaHorario(this.agenda_produto);
        }
      if (check == "false") {
        this.showLabel = false;
        //  eval("this.cor_" + val + "='error'");
        this.deletaDiaHorario(this.agenda_produto);
      }
  },
    deletaDiaHorario(agenda) {
      axios.post(`/adm/config/agenda/deleta`, agenda).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = "Horário excluido!";
          //this.buscaProdutos();
        }
      });
    },
    atualizaDiaHorario(agenda) {
      if(!this.$can('config_update|admin.loja')) {
        this.snackbar = true;
        this.textSnack = "Você não tem permissão para executar esta ação.";
        return;
      }
        axios.post(`/adm/config/agenda`, agenda).then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Alterado com sucesso!";
            //this.buscaProdutos();
          }
        });
    },
    mudarQtde(val, dia) {
      this.agenda.dia_semana = dia;
      this.agenda.qtd_max = val;
      this.atualizaDiaHorario(this.agenda);
    },
    selHoraInicial(val, dia) {
      this.agenda_produto.dia_semana = dia;
      this.agenda_produto.hora_inicial = val;
      this.agenda_produto.hora_final = "";
      this.agenda_produto.qtd_max = eval("this.qtd_max_" + dia);
      this.atualizaDiaHorario(this.agenda_produto);
    },
    selHoraFinal(val, dia) {
      this.agenda_produto.dia_semana = dia;
      this.agenda_produto.hora_final = val;
      this.agenda_produto.hora_inicial = "";
      this.agenda_produto.qtd_max = eval("this.qtd_max_" + dia);
      this.atualizaDiaHorario(this.agenda_produto);
    },
    marcaTodosEntrega() {
      this.$nextTick(() => {
        let el = document.getElementById("todos_dias");
        if (el.checked) {
          //if (this.dias_entrega[0] == 0) {
          this.dias_entrega = ["0"];
          //this.dias_entrega = ["0", "1", "2", "3", "4", "5", "6", "7"];
        } else {
          this.dias_entrega = [];
        }
      });
      this.mudarValor("dias_semana", this.dias_entrega);
    },
    marcaTodos() {
      if (this.config.todos == "todos") {
        this.config.dia_1 = "true";
        this.mudarValor("dia1", this.config.dia_1);
        this.config.dia_2 = "true";
        this.mudarValor("dia2", this.config.dia_2);
        this.config.dia_3 = "true";
        this.mudarValor("dia3", this.config.dia_3);
        this.config.dia_4 = "true";
        this.mudarValor("dia4", this.config.dia_4);
        this.config.dia_5 = "true";
        this.mudarValor("dia5", this.config.dia_5);
        this.config.dia_6 = "true";
        this.mudarValor("dia6", this.config.dia_6);
        this.config.dia_7 = "true";
        this.mudarValor("dia7", this.config.dia_7);
      } else {
        this.config.dia_1 = "false";
        this.mudarValor("dia1", this.config.dia_1);
        this.config.dia_2 = "false";
        this.mudarValor("dia2", this.config.dia_2);
        this.config.dia_3 = "false";
        this.mudarValor("dia3", this.config.dia_3);
        this.config.dia_4 = "false";
        this.mudarValor("dia4", this.config.dia_4);
        this.config.dia_5 = "false";
        this.mudarValor("dia5", this.config.dia_5);
        this.config.dia_6 = "false";
        this.mudarValor("dia6", this.config.dia_6);
        this.config.dia_7 = "false";
        this.mudarValor("dia7", this.config.dia_7);
      }
    },
    checkStatus(valor) {
      if (valor == "true") {
        return "Aberta";
      } else {
        return "Fechada";
      }
    },
    checkStatusManutencao(valor) {
      if (valor == "true") {
        return "off-line";
      } else {
        return "on-line";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getStatus(status) {
      if (status === "Cancelada") {
        return "cancelada";
      }
    },
    mudarValor(campo, valor) {
      if(this.$can('config.update|admin.loja')){
        
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        /*  if(campo =="tempo_entrega"){
          data:{tempo_entrega:valor}
        }*/
        var formData = new FormData();
        formData.append(campo, valor);
        axios
          .post(`/config`, formData, config)
          .then((response) => {
            if (response.data.error) {
              //  this.textSnack = response.data.error;
              //  this.snackbar = true;
            } else {
              //this.buscaProdutosSgt();
              this.snackbarSuccess = true;
              this.textSucesso = response.data.msg;
              this.categoria.descricao = "";
            }
          })
          .catch((e) => {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbar = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbar = true;
            }
          });
        }
    },
    mudarValorEntrega(campo, valor) {
      //console.log("val" + valor);
      if (valor != "0") {
        var index = this.dias_entrega.indexOf("0");
        //alert(index);
        if (index > -1) {
          this.dias_entrega.splice(index, 1);
        }

        //data:{tempo_entrega:valor}
      }
      //console.log(this.dias_entrega);
      var formData = new FormData();
      formData.append(campo, valor);
      axios
        .post(`/config`, formData)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.categoria.descricao = "";
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    gerarPdf() {
      this.buscaExtratoPdf();
    },
    gerarQrcode() {
      this.loading = true;
      axios.get(`/config/qrcode`).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
          this.lista = [];
        } else {
          document.getElementById("linkDownload").href = response.data.url;
          document.getElementById("linkDownload").click();
        }
        this.loading = false;
      });
    },
    alterarHorarios() {
      axios
        .post(`/config/horarios`, { horarios: this.horarios_entrega })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.categoria.descricao = "";
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
    listaHorarios() {
      axios.get(`/config/horarios`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.horarios_entrega = response.data;
          // console.log(response.data);
        }
      });
    },

    lista() {
      axios.get(`/config/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.config.pedido_minimo = response.data.pedido_minimo;
          this.config.taxa_gratis = response.data.taxa_gratis;
          this.config.km_taxa_gratis = response.data.km_taxa_gratis;
          this.config.key_maps = response.data.key_maps;
          this.config.tempo_entrega = response.data.tempo_entrega;
          this.config.hora_inicial = response.data.hora_inicial;
          this.config.hora_final = response.data.hora_final;
          this.config.hora_abertura_sabado = response.data.hora_abertura_sabado;
          this.config.hora_fechar_sabado = response.data.hora_fechar_sabado;
          this.config.hora_abertura_domingo = response.data.hora_abertura_domingo;
          this.config.hora_fechar_domingo = response.data.hora_fechar_domingo;

          this.config.retira_loja = response.data.retira_loja;
          this.config.url_loja = response.data.url_loja;
          this.config.url_logo = response.data.url_logo;
          this.config.manutencao = response.data.manutencao;
          this.config.aberto = response.data.aberto;
          this.config.chk_taxa_bairro_distancia = response.data.chk_taxa_bairro_distancia;
          this.config.dia_1 = response.data.dia1;
          this.config.dia_2 = response.data.dia2;
          this.config.dia_3 = response.data.dia3;
          this.config.dia_4 = response.data.dia4;
          this.config.dia_5 = response.data.dia5;
          this.config.dia_6 = response.data.dia6;
          this.config.dia_7 = response.data.dia7;
          this.dias_entrega = response.data.dias_semana;
          this.config.qtde_mesa = response.data.qtde_mesa;
          this.config.alerta_sonoro_pedido_recebido =
            response.data.alerta_sonoro_pedido_recebido;

          this.config.aceita_pedido_normal = response.data.aceita_pedido_normal;
          this.config.aceita_dinheiro = response.data.aceita_dinheiro;
          this.config.aceita_pix = response.data.aceita_pix;
          
          this.config.aceita_cartao = response.data.aceita_cartao;
          this.config.aceita_encomenda = response.data.aceita_encomenda;
          this.config.encomenda_dia_atual = response.data.encomenda_dia_atual;
          this.config.qtd_hora_encomenda = response.data.qtd_hora_encomenda;
          this.config.pagto_entrega = response.data.pagto_entrega;
          this.config.chk_comanda = response.data.chk_comanda;

          // console.log(response.data);
        }
      });
    },
    mudarStatus(status) {
      console.log(status);
    },

    getAgenda(id_produto, tipo) {
      //this.zeraInformacoes();

      axios.get(`/adm/config/agenda`).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.buscaProdutos();
          var json = response.data;
          this.serializa(json);
        }
      });
    },
    serializa(json) {
      console.log("json" + json.length);

      for (var prop in json) {
        eval("this.dia_h" + json[prop].dia_semana + "=true");
        eval("this.dia_" + json[prop].dia_semana + "='true'");
        //  eval("this.cor_" + json[prop].dia_semana + "='botao_sucesso'");

        eval(
          "this.hora_inicial_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_inicial +
            "'"
        );
        eval(
          "this.hora_final_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_final +
            "'"
        );
        eval(
          "this.hora_inicial_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_inicial +
            "'"
        );
        eval(
          "this.hora_final_" +
            json[prop].dia_semana +
            "='" +
            json[prop].hora_final +
            "'"
        );
        eval(
          "this.qtd_max_" +
            json[prop].dia_semana +
            "='" +
            json[prop].qtd_max +
            "'"
        );
        console.log(
          "obj." +
            prop +
            " = dia" +
            json[prop].dia_semana +
            "va" +
            json[prop].hora_inicial
        );
      }
    },
  },
};
</script>
<style scoped>
.cancelada {
  color: red;
}
.v-color-picker__preview {
 
    display: none!important;
}
.v-color-picker__controls {
    display: none !important;
}
</style>
